import Alert from "@mui/material/Alert"
import React, { useState } from "react"
import { useForm } from "react-hook-form"
import * as style from "./style.module.css"
import Layout from "/src/components/Layout"
import Seo from "/src/components/Seo"
import TopVisual from "/src/components/TopVisual"
import json from "/src/siteData.json"

const phoneNumber = json.footer.phoneNumber

const Page = ({ pageContext }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      inquiryType: pageContext.term1[0].title,
    },
  })
  const [alertMessage, setAlertMessage] = useState("")
  const [alertType, setAlertType] = useState("success")

  const transformDataToSend = (formData, terms) => {
    return {
      inquiryType: formData.inquiryType,
      text: terms.map(term => ({
        question: term.title,
        answer: formData[term.title] ?? "",
      })),
      inquiryDetails: formData.inquiryDetails,
    }
  }

  const onSubmit = async formData => {
    const transformedData = transformDataToSend(formData, pageContext.term2)
    try {
      const response = await fetch(pageContext.endpoint + "contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(transformedData),
      })
      if (!response.ok) {
        throw new Error(response.statusText)
      } else {
        if (window.gtag) {
          window.gtag("event", "contact_form_submitted", {
            event_category: "Contact Form",
            event_label: "Submit",
            value: 1,
          })
        }
        setAlertMessage("お問い合わせ頂きましてありがとうございました。")
        setAlertType("success")
        window.scrollTo({ top: 400, behavior: "smooth" })
      }
    } catch (error) {
      setAlertMessage("送信に失敗しました。")
      setAlertType("error")
      window.scrollTo({ top: 400, behavior: "smooth" })
    }
  }

  return (
    <Layout>
      <TopVisual
        mainTitle={"CONTACT"}
        dynamicTitle={pageContext.title}
        media={pageContext.media}
      />
      <div className={style.container}>
        <div className={style.introduction}>
          <p>
            弊社へのお問い合わせは、お電話、もしくは下記のフォームから送信してください。
          </p>
        </div>
        <div className={style.tel}>
          TEL:<a href={`tel:+81${phoneNumber}`}>{phoneNumber}</a>
        </div>

        <form action="/" method="post" onSubmit={handleSubmit(onSubmit)}>
          {alertMessage && (
            <div className={style.alertarea}>
              <Alert severity={alertType} style={{ marginBottom: "50px" }}>
                {alertMessage}
              </Alert>
            </div>
          )}
          <fieldset>
            <legend>ご用件</legend>
            <div className={style.radioarea}>
              {pageContext.term1.map((term, index) => {
                return (
                  <label key={index}>
                    <input
                      type="radio"
                      value={term.title}
                      {...register("inquiryType", { required: true })}
                    />
                    {term.title}
                  </label>
                )
              })}
            </div>

            {pageContext.term2.map((term, index) => {
              return (
                <div className={style.inputarea} key={index}>
                  <label htmlFor={term.title}>
                    <span>*</span>
                    {term.title}
                  </label>
                  <input
                    type="text"
                    id={term.title}
                    {...register(term.title, {
                      required: "入力が必須の項目です。",
                    })}
                  />
                  <p className={style.error}>
                    {errors[term.title] && errors[term.title].message}
                  </p>
                </div>
              )
            })}

            <div className={style.inputarea}>
              <label htmlFor="inquiry">
                <span>*</span>
                お問い合わせ内容
              </label>
              <textarea
                id="inquiry"
                {...register("inquiryDetails", {
                  required: "入力が必須の項目です。",
                })}
              ></textarea>
              <p className={style.error}>
                {errors.inquiryDetails && errors.inquiryDetails.message}
              </p>
            </div>

            <div className={style.buttonarea}>
              <button type="submit" disabled={!isValid}>
                送信
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </Layout>
  )
}

export default Page

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />
}
